import accounting from 'accounting'
import get from 'lodash/get'

// The plan is from our database, the coupon is from Stripe
export function priceWithDiscount(plan, price, coupon) {
  if (doesDiscountApplyToPlan(plan, coupon)) {
    if (coupon.percentOff) {
      const discount = coupon.percentOff / 100
      const discountedPrice = price - price * discount

      return discountedPrice
    } else {
      const discountedPrice = price - coupon.amountOff

      return discountedPrice
    }
  }

  return price
}

// The plan is from our database, the coupon is from Stripe
export function doesDiscountApplyToPlan(plan, coupon) {
  if (coupon.appliesTo) {
    return coupon.appliesTo.products.includes(plan.sku)
  }

  return true
}

export function nextBilledSubscriptionAmount(subscription) {
  if (get(subscription, ['type'], '') === 'stripe') {
    return formatTotalCurrency(get(subscription, ['upcomingInvoice', 'amountDue'], 0) / 100)
  } else {
    return formatTotalCurrency(get(subscription, ['total', 'amount'], 0) / 100)
  }
}

export function nextBilledAmount(discount, price, plan, selectedSeats) {
  if (['once', 'repeating'].includes(get(discount, 'duration', 'once'))) {
    return formatTotalCurrency((get(plan, ['price', 'amount'], 0) + seatMultiplier(plan, selectedSeats)) / 100)
  } else {
    return formatTotalCurrency(price)
  }
}

export function seatMultiplier(plan, seats) {
  const multiplier = seats - plan.seats

  return multiplier * get(plan, ['seatUpgradePrice', 'amount'], 0)
}

export function getSubscriptionAmount(subscription) {
  if (subscription.type === 'stripe') {
    return get(subscription, ['latestInvoice', 'amountPaid'], 0)
  } else {
    return get(subscription, ['total', 'amount'], 0)
  }
}

export function getCurrentDiscountLengthLabel(discount) {
  // Currently in Stripe the options are 'once', 'forever', 'repeating'
  // https://docs.stripe.com/api/coupons/object#coupon_object-duration

  switch (get(discount, 'duration', 'once')) {
    case 'once': {
      return ' for the first year'
    }
    case 'repeating': {
      const years = get(discount, 'durationInMonths', 12) / 12
      return ` for the next ${yearsLabel(years)}`
    }
    default: {
      return 'per year'
    }
  }
}

export function yearsLabel(years) {
  return years > 1 ? `${years} years` : 'year'
}

export function isProratedAmount(subscription) {
  return get(subscription, ['latestInvoice', 'lines', 'data'], []).find((line) => line.proration)
}

export function formatTotalCurrency(amount) {
  let precision = 0

  if (amount % 1 !== 0) {
    precision = 2

    return accounting.formatMoney(amount, { precision: precision }).split('.')
  }

  return [accounting.formatMoney(amount, { precision: precision })]
}

export function discountRepeatingYears(discount) {
  return get(discount, 'durationInMonths', 12) / 12
}
